import { Input, type GetProps } from 'antd';
import cs from "classnames";
import Styles from "./Styles.module.scss";

type SearchProps = GetProps<typeof Input.Search>;

export default function MPSearch({ className, ...props }: MPSearchProps) {
    return (
        <>
            <Input.Search
                className={cs(Styles?.MPInput, className)}
                {...props}
            />
        </>
    );
}

export interface MPSearchProps extends SearchProps {

}
